import userMenuLayoutConfig from '../../../../../config/layout/userMenu'
import { canUser } from '../../../../../common/utils/userAuthorization'

const parsePath = (path, username, site) => {
  return path
    .replace('{{username}}', username)
    .replace('{{currentSite}}', site)
}

const canViewBlock = (user, block) => {
  if (block.requires) {
    return canUser(user, block.requires)
  } else {
    return true
  }
}

const blockEntriesForUser = (user, site, entries) => {
  return entries.filter((entry) => {
    if (entry.requires) {
      return canUser(user, entry.requires, site)
    } else {
      return true
    }
  })
}

const createNewEntry = (entry, username, site, isLastEntry) => {
  let newEntry = {
    path: parsePath(entry.path, username, site),
    label: entry.label,
    isLastEntry: isLastEntry
  }

  if (entry.showCredit) {
    newEntry.showCredit = entry.showCredit
  }

  if (entry.creditLabel) {
    newEntry.creditLabel = entry.creditLabel
  }

  return newEntry
}

export default (user, site) => {
  const username = user.profile.username

  return userMenuLayoutConfig.blocks.reduce((collection, block) => {
    if (canViewBlock(user, block)) {
      if (block.title) {
        collection.push({title: block.title.replace('{{username}}', username)})
      }

      let entries = blockEntriesForUser(user, site, block.entries)
      const last = entries.pop()

      entries.forEach((entry) => {
        collection.push(
          createNewEntry(entry, username, site, false)
        )
      })

      collection.push(
        createNewEntry(last, username, site, true)
      )
    }

    return collection
  }, [])
}



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/user/menuBuilder.js